import { createStore } from 'vuex'
// @ts-ignore
import createPersistedState from 'vuex-persistedstate'

import user from './user'
import common from './common'
import assess from './assess'
import recruit from './recruit'
import pageState from './pageState'
import further from './further'
import diagnoseCenter from './diagnoseCenter'
import growthCenter from './growthCenter'

const createPersisted = createPersistedState({
  storage: localStorage,
  filter: (mutation) => {
    return mutation.type !== 'clearLoginInfo'
  },
  reducer(state: { pageState: any; common: any; user: any; further: any }) {
    return {
      common: state.common,
      user: state.user,
      further: state.further,
    }
  },
})

export default createStore({
  modules: {
    user,
    common,
    assess,
    recruit,
    pageState,
    further,
    diagnoseCenter,
    growthCenter,
  },
  plugins: [createPersisted],
})
